import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/arrow-active.png'


const _withScopeId = n => (_pushScopeId("data-v-95110586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "article-list bx" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "最新消息", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sub-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 更多消息 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { MessageFetch } from '@/api/request';
import { ISjqnwArticleProps, PaginationProps } from '@/api/type';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const list = ref<ISjqnwArticleProps[]>([]);
const pagination = ref<PaginationProps>({
  pageNum: 1,
  pageSize: 5
});
const init = async() => {
  const res = await MessageFetch.getArticleList({
    ...pagination.value,
    sjqnwArticleType: '1'
  });
  if (res.code === '00') {
    list.value = res.body;
  }
};

const toDetail = (item: ISjqnwArticleProps) => {
  router.push({
    name: 'article',
    query: { articleId: item.id }
  });
};

const toList = () => {
  router.push({
    name: 'message'
  });
};
onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.slice(0, 4), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (toDetail(item))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, "· " + _toDisplayString(item.articleTitle), 1),
              _hoisted_7
            ])
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "more",
        onClick: toList
      }, _hoisted_10)
    ])
  ]))
}
}

})